module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/adambalee/Client Sites/untuck/valet/penn-pennfund/wp-content/themes/penn-fund/node_modules/axios/index.js
// module id = 15
// module chunks = 0 1